import { Shimmer } from '@components';
import { Icon as BlueIcon } from '@blueprintjs/core';
import {
  AuthorContainerLeftShimmer,
  ChatStatus,
  Close,
  Header,
  Message,
  Messages,
  AuthorContainerShimmer,
  Title,
  TitleContainer,
  ChatStatusWrapper,
  RequestDetailsText,
} from './IdentificationRequestChat.styles';

interface IMessage {
  align: 'left' | 'right';
}

const MessageLoader = ({ align }: IMessage) => {
  return (
    <Message align={align}>
      <AuthorContainerShimmer>
        <AuthorContainerLeftShimmer>
          <Shimmer
            style={{ height: 24, width: 24, borderRadius: 50 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
          <Shimmer
            style={{ height: 12, width: 140, borderRadius: 4 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
        </AuthorContainerLeftShimmer>

        <Shimmer
          style={{ height: 12, width: 60, borderRadius: 4 }}
          primary="#f1f1f1"
          secondary="#ececec"
        />
      </AuthorContainerShimmer>

      <Shimmer
        style={{ minHeight: 68, minWidth: 271, borderRadius: 8 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
    </Message>
  );
};

const IdentificationRequestsChatLoading = () => {
  return (
    <>
      <Header>
        <TitleContainer>
          <Title>Match Request</Title>
          <Shimmer
            style={{ height: 14, width: 55, borderRadius: 4 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
        </TitleContainer>
        <Close>
          <BlueIcon icon="cross" color="#8F95B2" />
        </Close>
      </Header>

      <ChatStatusWrapper>
        <ChatStatus>
          <Shimmer
            style={{ height: 6, width: 6, borderRadius: 50 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
          <Shimmer
            style={{ height: 14, width: 80, borderRadius: 4 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
        </ChatStatus>

        <RequestDetailsText>See Request Details</RequestDetailsText>
      </ChatStatusWrapper>

      <Messages>
        <MessageLoader align="left" />
        <MessageLoader align="right" />
        <MessageLoader align="left" />
      </Messages>
    </>
  );
};

export { IdentificationRequestsChatLoading };
